// Conteudo dos Termos de Uso e da Politica de Privacidade do ConsulTrack.
// Texto base alinhado a LGPD (Lei nº 13.709/2018). Pode ser customizado.

export const TERMS_LAST_UPDATE = 'Junho de 2026';

export const TERMS_OF_USE = [
  {
    title: '1. Aceitação dos Termos',
    body:
      'Ao acessar e utilizar o sistema ConsulTrack ("Sistema"), o usuário declara que leu, ' +
      'compreendeu e concorda integralmente com estes Termos de Uso e com a Política de Privacidade. ' +
      'Caso não concorde, o usuário não deverá utilizar o Sistema.',
  },
  {
    title: '2. Objeto e Finalidade',
    body:
      'O ConsulTrack é destinado ao agendamento e à gestão de consultas e exames em unidades públicas ' +
      'de saúde, incluindo o cadastro de pacientes, a marcação de vagas, a gestão de procedimentos e a ' +
      'geração de relatórios. O uso do Sistema é restrito a fins profissionais e administrativos ' +
      'relacionados à prestação de serviços de saúde.',
  },
  {
    title: '3. Acesso e Credenciais',
    body:
      'O acesso é pessoal e intransferível. O usuário é responsável por manter a confidencialidade de ' +
      'suas credenciais (login e senha) e por todas as atividades realizadas em sua conta. O ' +
      'compartilhamento de credenciais é proibido. O Sistema permite apenas uma sessão ativa por usuário.',
  },
  {
    title: '4. Responsabilidades do Usuário',
    body:
      'O usuário compromete-se a: (a) utilizar o Sistema em conformidade com a legislação vigente e com ' +
      'as normas internas do órgão; (b) inserir dados verídicos, completos e atualizados; (c) não acessar, ' +
      'divulgar ou utilizar dados de pacientes para finalidades distintas das autorizadas; (d) zelar pelo ' +
      'sigilo das informações de saúde a que tiver acesso.',
  },
  {
    title: '5. Sigilo e Dados Sensíveis de Saúde',
    body:
      'Os dados tratados no Sistema incluem dados pessoais e dados pessoais sensíveis de saúde, protegidos ' +
      'por sigilo profissional e pela legislação aplicável. O usuário reconhece o dever de confidencialidade ' +
      'e responde, civil e administrativamente, por eventual uso indevido.',
  },
  {
    title: '6. Uso Adequado',
    body:
      'É vedado: (a) tentar burlar mecanismos de segurança ou de controle de acesso; (b) realizar ' +
      'engenharia reversa, cópia ou extração não autorizada de dados; (c) inserir conteúdo ilícito, ' +
      'ofensivo ou que viole direitos de terceiros; (d) utilizar o Sistema para finalidades estranhas ' +
      'às atividades de saúde.',
  },
  {
    title: '7. Disponibilidade e Suporte',
    body:
      'O Sistema poderá passar por manutenções programadas ou eventuais indisponibilidades. Empenham-se ' +
      'esforços razoáveis para garantir a continuidade do serviço, sem, contudo, assegurar funcionamento ' +
      'ininterrupto ou isento de falhas.',
  },
  {
    title: '8. Auditoria',
    body:
      'As ações realizadas no Sistema são registradas em trilha de auditoria, para fins de segurança, ' +
      'rastreabilidade e cumprimento de obrigações legais.',
  },
  {
    title: '9. Alterações dos Termos',
    body:
      'Estes Termos podem ser atualizados a qualquer momento. Quando houver alteração relevante, será ' +
      'solicitado novo aceite ao usuário no acesso seguinte.',
  },
];

export const PRIVACY_POLICY = [
  {
    title: '1. Controlador e Tratamento de Dados',
    body:
      'O tratamento de dados pessoais no ConsulTrack observa a Lei Geral de Proteção de Dados (Lei nº ' +
      '13.709/2018 - LGPD). O órgão de saúde responsável atua como controlador dos dados, definindo as ' +
      'finalidades e os meios de tratamento.',
  },
  {
    title: '2. Dados Coletados',
    body:
      'São tratados dados de identificação de pacientes (nome, CPF, Cartão SUS, data de nascimento, ' +
      'endereço e telefone), dados de agendamento (procedimentos, datas, unidades) e dados de usuários ' +
      'do Sistema (nome, e-mail, perfil de acesso e registros de auditoria).',
  },
  {
    title: '3. Finalidade do Tratamento',
    body:
      'Os dados são tratados exclusivamente para o agendamento e a gestão de consultas e exames, a ' +
      'emissão de relatórios e comprovantes, o cumprimento de obrigações legais e regulatórias e a ' +
      'segurança do Sistema.',
  },
  {
    title: '4. Base Legal',
    body:
      'O tratamento fundamenta-se, entre outras hipóteses, na execução de políticas públicas, na tutela ' +
      'da saúde, no cumprimento de obrigação legal e no legítimo interesse, conforme os artigos 7º e 11 ' +
      'da LGPD aplicáveis a dados sensíveis de saúde.',
  },
  {
    title: '5. Compartilhamento',
    body:
      'Os dados não são comercializados. O compartilhamento ocorre apenas quando necessário para a ' +
      'prestação do serviço de saúde, para o cumprimento de obrigação legal ou mediante determinação de ' +
      'autoridade competente.',
  },
  {
    title: '6. Segurança da Informação',
    body:
      'São adotadas medidas técnicas e administrativas de segurança, como controle de acesso por perfil ' +
      '(RBAC), autenticação por senha criptografada, sessão única por usuário, trilha de auditoria e ' +
      'backups periódicos, visando proteger os dados contra acessos não autorizados e incidentes.',
  },
  {
    title: '7. Retenção e Eliminação',
    body:
      'Os dados são mantidos pelo período necessário ao cumprimento das finalidades e das obrigações ' +
      'legais. Registros de atendimentos realizados são arquivados conforme as rotinas do Sistema e a ' +
      'legislação aplicável.',
  },
  {
    title: '8. Direitos do Titular',
    body:
      'Nos termos da LGPD, o titular pode solicitar confirmação de tratamento, acesso, correção, ' +
      'anonimização, portabilidade e informações sobre o compartilhamento de seus dados, mediante ' +
      'requisição ao órgão controlador.',
  },
  {
    title: '9. Encarregado (DPO) e Contato',
    body:
      'Solicitações relativas à proteção de dados devem ser direcionadas ao encarregado pelo tratamento ' +
      'de dados (DPO) do órgão de saúde responsável pelo Sistema.',
  },
];
